<template>
    <div class="required field" :class="{'error': isError}">
        <label>Segment File Definitions</label>

        <div v-for="(option, index) in fileDefinitions" :key="option.vueId" class="file-definition">
            <div>
                <input type="hidden" v-if="option.id" :name="`fileDefinitions[${index}][id]`" :value="option.id">
                <div class="ui labeled input">
                    <label class="ui label">Character Name:</label>
                    <input type="text" :name="`fileDefinitions[${index}][name]`" v-model="option.name">
                </div>
                <div class="ui labeled input">
                    <label class="ui label">Max Name Length:</label>
                    <input type="number" :name="`fileDefinitions[${index}][max_length]`" v-model="option.max_length" width="10px">
                </div>
            </div>
            <button class="ui icon button" @click.prevent="removeOption(option.id)"><i class="trash icon"></i></button>
        </div>

        <div class="field">
            <button class="ui mini button" @click.prevent="addOption">Add Option</button>
        </div>
    </div>
</template>
<style>
.file-definition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    margin-top: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid gray;
}
.file-definition div {
    margin-bottom: 5px;
}
</style>
<script>
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'SegmentDefinitions',
    props: {
        initialOptions: {
            type: Array,
            default: () => []
        },
        isError: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fileDefinitions: this.initialOptions.map((option) => {
                option.vueId = uuidv4()
                return option
            })
        }
    },
    methods: {
        addOption() {
            this.fileDefinitions.push({
                vueId: uuidv4(),
                name: 'Link',
                max_length: 12
            })
        },
        removeOption(id) {
            const index = this.fileDefinitions.findIndex(option => option.id === id)
            if (index == -1) { return; }
            this.fileDefinitions.splice(index, 1)
        }
    }
}
</script>